export default __webpack_public_path__ + "static/media/img-transcription.9e897dc1.jpg";